import { getBrandNameById, getCanonicalPagePath } from "@platformx/utilities";

/**
 * The canonical path a page should show and save (KIWI-6401).
 *
 * The stored `PageSettings.PageURL` is the source of truth. It is used as-is while the slug is
 * unchanged — the stored path ends with `/<slug>`, so no extra "original slug" state is needed —
 * and rebuilt only when the editor changes the slug, from the page's own primary brand
 * (`pageModel.brand_name`, carried from the read-side `responseBrandname`). The dropdown brand is
 * just the fallback for a brand-new page with no brand yet. Without this, a page shared to another
 * primary brand kept showing the dropdown brand's URL in the editor.
 */
export const resolvePageCanonicalPath = ({
  slug,
  language,
  storedPath = "",
  brandId = "",
}: {
  slug?: string;
  language: string;
  storedPath?: string;
  brandId?: string;
}): string => {
  if (!slug) return storedPath;
  if (storedPath && storedPath.endsWith(`/${slug}`)) return storedPath;
  return (
    getCanonicalPagePath(slug, language, "sitepage", getBrandNameById(brandId || "")) || storedPath
  );
};
